<template lang="pug">
  LocationForm(
    :post-save-action="add"
    :show-buttons="false"
    :two-column-layout="false"
  )
</template>

<script>
  import { mapStores } from 'pinia'
  import { useLocationsStore } from '../../../../../stores/locations'

  import LocationForm from '../../../../../pages/locations/shared/form.vue'

  export default {
    components: {
      LocationForm
    },

    computed: {
      ...mapStores(useLocationsStore),
    }
  }
</script>
